
import { Highlight } from "@/utils/views/highlight";
import Vue from "vue";
import AppColorPicker from "@/components/ColorPicker.vue";

export default Vue.extend({
	props: {
		value: {
			type: Object as ()=>Highlight,
			required: true
		}
	},
	components: {
		AppColorPicker
	},
	i18nEx: {
		componentPrefix: "components.layout-editor"
	}
});
